
export default {
  name: 'FilterDropdown',
  props: {
    filterLabel: {
      type: String,
      required: true,
    },
    filterField: {
      type: String,
      required: true,
    },
    filterCount: {
      type: Number,
      default: 0,
    },
    openedFilter: {
      type: String,
      default: '',
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dropdownToggled() {
      return this.filterField === this.openedFilter
    },
  },
  mounted() {
    document.addEventListener('click', this.closeDropdown)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeDropdown)
  },
  methods: {
    toggleDropdown(ev) {
      if (ev.srcElement.classList.contains('dropdown-content')) {
        return
      }
      if (this.dropdownToggled) {
        this.$emit('setOpenedDropdown', null)
      } else {
        this.$emit('setOpenedDropdown', this.filterField)
      }
    },
    closeDropdown(event) {
      event.stopPropagation()

      if (!event.srcElement.classList.contains('fdc')) {
        this.$emit('setOpenedDropdown', null)
      }
    },
  },
}
